import ApiController, { ApiRequest } from "../controller";

class GiftCardModule extends ApiController {
  resource = "/giftcard";

  giftcard(id, signature) {
    const data = {
      id,
      signature
    }

    const request = new ApiRequest({
      method: "POST",
      url: `/giftcard`,
      body: data
    });

    return this.request<any>(request);
  }

  claim(id, signature, customer, claim) {
    const requestCustomer: any = {}

    if (customer.id) {
      requestCustomer.id = customer.id
    } else {
      requestCustomer.attributes = customer.fields
      requestCustomer.customFields = customer.customFields
      requestCustomer.acceptConsent = customer.privacyConsentAccepted
      requestCustomer.acceptMarketingConsent = customer.marketingConsentAccepted
    }

    const data = {
      id,
      signature,
      customer: requestCustomer,
      claim
    }

    const request = new ApiRequest({
      method: "POST",
      url: `/claim`,
      body: data
    });

    return this.request<any>(request);
  }

  purchase(action, customer, card, to, from, message, deliveryDate, termsAccepted, paymentData, paymentParams) {
    const requestCustomer: any = {}

    if (customer.id) {
      requestCustomer.id = customer.id
    } else {
      requestCustomer.attributes = customer.fields
      requestCustomer.customFields = customer.customFields
      requestCustomer.acceptConsent = customer.privacyConsentAccepted
      requestCustomer.acceptMarketingConsent = customer.marketingConsentAccepted
    }

    const data: any = {
      action,
      customer: requestCustomer,
      card: { amount: card.amount, image: card.image },
      to: { name: to.name, email: to.email },
      from: { name: from.name },
      message,
      deliveryDate: deliveryDate ?? null,
      termsAccepted,
      payment: {}
    }

    if (paymentData) {
      data.payment.data = paymentData
    }

    if (paymentParams) {
      data.payment.params = paymentParams
    }

    const request = new ApiRequest({
      method: "POST",
      url: `/purchase`,
      body: data
    });

    return this.request<any>(request);
  }
}

export default GiftCardModule;